import React, { useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import { Box } from '@mui/material';

export default function PaginationItem({ changePage, data }) {
	const [page, setPage] = useState(1);
	useEffect(() => {
		if (data) {
			setPage(data.pages);
		}
	}, [data]);

	return (
		<Box
			sx={{
				'& > *': {
					marginTop: 2,
					justifyContent: 'center',
					display: 'flex',
				},
			}}
		>
			<Pagination
				count={page}
				shape='rounded'
				onChange={(event, val) => changePage(val)}
			/>
		</Box>
	);
}
